<template>
    <div class="tools-tab tools-tab-flags">

        {{ $t('page.roster.tools.application') }}

        <br><br>

        <action @click.native="allow" icon="check" color="green">{{ $t('common.button.confirm') }}</action>

        <action @click.native="deny" icon="cancel" color="red">{{ $t('common.button.deny') }}</action>
    </div>
</template>

<script>
import { mapState } from 'vuex';
// import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Flags',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    methods:
    {
        allow()
        {
            this.$http.put('/api/items/' + this.item.id + '/sign-out',
            {
                confirm: true
            })
            .then(response =>
            {
                let key = _.findIndex(this.shared.items, {id: this.item.id});

                // response contains item, we need to replace the whole item
                this.$set(this.shared.items, key, response.data);

                this.$tools.close();
            });
        },

        deny()
        {
            this.$http.put('/api/items/' + this.item.id + '/sign-out',
            {
                confirm: false
            })
            .then(response =>
            {
                this.item.flag = null;
                this.$tools.close();
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// Flags.vue?15678dc1